<template>
  <BaseLayout>
    <header class="bg-white shadow sm:sticky sm:top-[64px] z-30">
      <div class="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
        <slot name="breadcrumbs" />

        <div class="flex justify-between">
          <div class="flex space-x-4">
            <div v-if="$slots.headerIcon">
              <slot name="headerIcon" />
            </div>
            <h1 class="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              {{ props.pageTitle }}
            </h1>
          </div>

          <div v-if="$slots.headerActions" class="space-x-2 flex items-center">
            <slot name="headerActions" />
          </div>
        </div>
      </div>
    </header>
    <main>
      <div class="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
        <div class="px-4 sm:px-0">
          <slot />
        </div>
      </div>
    </main>

    <ToastContainer />
  </BaseLayout>

</template>

<script lang="ts" setup>
import BaseLayout from './BaseLayout.vue';
import ToastContainer from '@/components/toasts/ToastContainer.vue';

type AppLayoutProps = {
  pageTitle: string;
}

const props = defineProps<AppLayoutProps>();
</script>
